import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { useGlobal } from "../global/user";
import { Space, message as antdMessage } from "antd";
import { useFeatureGuide } from '../hooks/useFeatureGuide.js';
import PageDirector from "../container/PageDirector";
import UserTable from "../container/UserTable";
import CompanyTable from "../container/CompanyTable";
import FieldTable from "../container/FieldTable";
import MessageTable from "../container/MessageTable";
import ImageTableNew from "../container/ImageTableNew";
import CommunicationSettings from "../container/CommunicationSettings";
import { Tabs } from "antd";
import CustomHeader from "../container/Header";
import { tileLayer } from "leaflet";

export default function Setting() {
  const history = useHistory();
  const location = useLocation();
  const { user } = useGlobal();
  const [activeTab, setActiveTab] = useState("1");
  const [restoredFieldData, setRestoredFieldData] = useState(null);

  const stepsFromLocal = location.state?.restoreData?.pathSteps || [];
  useFeatureGuide({ 
    location, 
    setActiveTab, 
    setRestoredFieldData,
    stepsFromDB: stepsFromLocal 
  });

  const handleTabClick = (key, e) => {
    if (key === "7") {
      e.preventDefault();
      e.stopPropagation();

      const width = 1000;
      const height = 700;
      const left = (window.screen.width - width) / 2;
      const top = (window.screen.height - height) / 2;

      window.open(
        "https://beta.iotwebhub.net/IoT3#/tutorial",
        "SettingInstructionWindow",
        `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes,status=yes`
      );

      return;
    }

    setActiveTab(key);
  };

  useEffect(() => {
    if (user.class < process.env.REACT_APP_CONTROL_CALSS_LV) {
      history.push("/control");
      return;
    }
  }, [user, history]);

  const items = [
    {
      key: "1",
      label: "使用者設定",
      children: (
        <Space direction="vertical" style={{ width: "100%" }}>
          <UserTable />
        </Space>
      ),
    },
    {
      key: "2",
      label: "場域設定",
      children: (
        <Space direction="vertical" style={{ width: "100%" }}>
          <FieldTable />
        </Space>
      ),
    },
    ...(user.class >= process.env.REACT_APP_MANAGER_CALSS_LV
      ? [
          {
            key: "3",
            label: "公司設定",
            children: (
              <Space direction="vertical" style={{ width: "100%" }}>
                <CompanyTable />
              </Space>
            ),
          },
          {
            key: "4",
            label: "主機圖文通報設定",
            children: (
              <Space direction="vertical" style={{ width: "100%" }}>
                <MessageTable />
              </Space>
            ),
          },
          {
            key: "5",
            label: "Mail圖片通報設定",
            children: (
              <Space direction="vertical" style={{ width: "100%" }}>
                <ImageTableNew />
              </Space>
            ),
          },
          {
            key: "6",
            label: "通訊設定",
            children: (
              <Space direction="vertical" style={{ width: "100%" }}>
                <CommunicationSettings isActive={activeTab === "6"} />
              </Space>
            ),
          },
          {
            key: "7",
            label: "設定說明",
            children: null,
          },
        ]
      : []),
  ];

  return (
    <React.Fragment>
      <CustomHeader />
      <div className="container-fluid">
        <div className="page-container fade-in">
          <PageDirector />
          <Tabs defaultActiveKey="1" activeKey={activeTab} onTabClick={handleTabClick} items={items} className="px-0" />
        </div>
      </div>
    </React.Fragment>
  );
}